export const hasPermission = (user, permission) => Boolean(
  user?.is_admin || (user?.permissions || []).includes(permission)
);
